<template>
  <div>
    <v-btn
      class="ma-4 button_text--text"
      small
      :disabled="current_page === 1"
      elevation="4"
      @click="prevPage()"
      color="primary"
    >
      <v-icon> mdi-chevron-left </v-icon>
    </v-btn>

    <span class="mx-2">{{ current_page }}</span>

    <v-btn
      class="ma-4 button_text--text"
      small
      :disabled="!has_more"
      elevation="4"
      @click="nextPage()"
      color="primary"
    >
      <v-icon> mdi-chevron-right </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ["has_more", "paging_id"],
  data() {
    return {
      current_page: 1,
      page_marker: [""],
    };
  },
  mounted() {
    this.syncPaging();
  },
  watch: {
    $route() {
      this.syncPaging();
    },
  },
  methods: {
    nextPage() {
      this.current_page += 1;
      this.page_marker[this.current_page - 1] = this.paging_id;
      // hard copy router query params
      let query_params = JSON.parse(JSON.stringify(this.$route.query));
      // push page and id
      query_params["page"] = this.current_page;
      query_params["paging_id"] = this.paging_id;
      this.$router.push({ query: query_params });
    },

    prevPage() {
      this.current_page -= 1;
      // get first id
      const first_id = this.page_marker[this.current_page - 1];
      // hard copy and push page and id
      let query_params = JSON.parse(JSON.stringify(this.$route.query));
      query_params["page"] = this.current_page;
      query_params["paging_id"] = first_id;
      this.$router.push({ query: query_params });
    },

    refreshPaging() {
      // method for parent component to reset paging state
      this.current_page = 1;
      this.page_marker = [""];
    },

    syncPaging() {
      // sync paging to whats in the router
      this.current_page = parseInt(this.$route.query.page || 1);
    },
  },
};
</script>
